import Vue from 'vue'
import routes from './routes'
import Router from 'vue-router'
import {isLoggedIn} from '@/firebase/login'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
});

router.beforeEach((to, from, next) => {
  if(to.name === 'login') {
    next();
  } else {
    const loggedIn = isLoggedIn();
    if (loggedIn) {
      next()
    } else {
      next({ name: 'login' })
    }
  }

})
export default router
